module.exports = __webpack_public_path__ + "img/borderRightTriangleWhite.6046b106.svg";